import {useState} from 'react'
import { motion, AnimatePresence } from "framer-motion";
import AppearOnScroll from './AppearOnScroll';

function Dropdown(props) {
    const [open, setOpen] = useState(false);
    return (
      <AppearOnScroll>
      <div className="flex flex-col w-full py-4 bg-white cursor-pointer border-t border-lightgrey" >
        <div className="w-full flex flex-col md:flex-row justify-between px-4 gap-2 md:gap-0" onClick={() => setOpen(!open)}>
            <div className="">
                <h3 className="xl:text-xl text-lg text-left text-dark-900">{props.title}</h3>
            </div>
            <div className="flex flex-row gap-4 md:justify-normal justify-between">
                <h3 className="text-md text-dark-400">{props.year}</h3>
                <motion.div
                    animate={{ rotate: open ? 180 : 0 }}
                    transition={{ duration: 0.2 }} >
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="darkgrey" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 9l6 6l6 -6" /></svg>
                        </div>
                </motion.div>
            </div>
        </div>


        <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="pt-4 px-4 text-left text-gray-600">
              {props.info}
            </div>
          </motion.div>
        )}
        </AnimatePresence>
      </div>
      </AppearOnScroll>
    )
  }
  
  export default Dropdown;